import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import IUserMenu from '../../../interfaces/IUserMenu';
import IPermission from '../../../interfaces/IPermission';
import useGetPermission from "../../../hooks/useGetPermission"
const permissionsStore = createSlice({
  name: 'permissions',
  initialState: [] as IPermission[],
  reducers: {
    setPermission(_state, action: PayloadAction<IPermission[]>) {
      return [...action.payload];
    },
    invalidatePermissions() {
      return []
    }
  },
});

export default permissionsStore;
export const { setPermission, invalidatePermissions } = permissionsStore.actions;

export const usePerformAction = (menu: string, isWrite:boolean = false) => {
  var permission = useGetPermission();
  if (isWrite) {
    return permission && permission.some(x => x.url.endsWith(menu) && x.isWrite)
  } else {
    return permission && permission.some(x => x.url.endsWith(menu) && x.isRead)
  }
}
